import { render, staticRenderFns } from "./rupiahInput.vue?vue&type=template&id=0907ff8b"
import script from "./rupiahInput.vue?vue&type=script&lang=js"
export * from "./rupiahInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports